export const SIZES = {
  SMALL: 'small',
  LARGE: 'large'
}
